<template>
  <section class="singleDetails" id="details">
    <div class="singleDetails-left">
      <h2 class="singleDetails-title">{{ listing && listing.title }}</h2>
      <div class="singleDetails-singleParams singleParams">
        <div class="singleParams-section _price" v-if="listing && listing.priceValue">
          <div class="singleParams-key">{{ listing.priceValue | toCurrency }}</div>
          <div class="singleParams-value _price">
            <span>PRICE</span>
            <SvgComponent name="tip" tabindex="0" />
            <div class="singleParams-tip">Prices are subject to tax and service charges</div>
          </div>
        </div>
        <div class="singleParams-props">
          <div class="singleParams-section" v-if="listing && listing.beds">
            <div class="singleParams-key">
              <SvgComponent name="bed" />
              <span>{{ listing && listing.beds }} bd</span>
            </div>
            <div class="singleParams-value">BEDS</div>
          </div>
          <div class="singleParams-section" v-if="listing && listing.baths">
            <div class="singleParams-key">
              <SvgComponent name="bath" />
              <span>{{ listing && listing.baths }}{{ halfBathRender() }} ba</span>
            </div>
            <div class="singleParams-value">TOTAL BATHS</div>
          </div>
          <div class="singleParams-section" v-if="listing && listing.sqft">
            <div class="singleParams-key">
              <SvgComponent name="sqft" />
              <span>{{ listing && listing.sqft }} sqft</span>
            </div>
            <div class="singleParams-value">SQFT</div>
          </div>
          <div class="singleParams-section" v-if="listing && listing.acres">
            <div class="singleParams-key">
              <SvgComponent name="sqft" />
              <span>{{ listing && listing.acres }} ac</span>
            </div>
            <div class="singleParams-value">ACRES</div>
          </div>
        </div>
        <div class="singleParams-location">{{ listing && listing.address }}</div>
      </div>
    </div>
    <p class="singleDetails-text" v-if="listing && listing.Content.details">{{ textExpanded ? listing.Content.details : truncatedText }}<span
        v-if="isLong && !textExpanded"
        class="singleDetails-showMore"
        @click="textExpanded = true"
      >Show more <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></p>
  </section>
</template>

<script>
  import SvgComponent from '@/components/SvgComponent';

  

  export default {
    components: {
      SvgComponent,
    },
    props: ['listing'],
    data() {
      return {
        textExpanded: false,
        charLimit: this.$store?.getters?.desktop ? 1500 : 500,
      };
    },
    computed: {
      isLong() {
        return this.listing?.Content?.details?.length > this.charLimit;
      },
      truncatedText() {
        const text = this.listing?.Content?.details || '';
        if (text.length <= this.charLimit) return text;
        return text.slice(0, this.charLimit).replace(/\s+\S*$/, '') + '... ';
      },
    },
    methods:{
      halfBathRender() {
        
        if (!this.listing.halfbaths) {
          return '';
        }
        if (this.listing.halfbaths == 1) {
          return '.5';
        }
        if (this.listing.halfbaths > 1) {
          return ` + ${this.listing.halfbaths}half`;
        }
      },
    }
  };
</script>

<style lang="scss">
  .singleDetails {
    padding: 150px 0;
    display: flex;
    /* flex-direction: column; */
    /* @include gap(50px, col); */
    gap: 30px;
    position: relative;
    background: #FFFAF3;


    &-left {
      display: flex;
      flex-direction: column;
      min-width: 495px;

      @include tablet {
        min-width: 40%;
      }

      @include miniTablet {
        height: 100%;
      }

      @include phone {
        min-width: 100%;
      }
      
    }

    &-title {
      font-size: 72px;
      line-height: 77px;
      font-family: 'Abhaya Libre';
      color: #1F1E1E;
      @include middle {
        
        /* line-height: 43px; */
      }
      @include tablet {
        font-size: 42px;
        line-height: 43px;
      }
     
    }
    &-text {
      font-size: 18px;
      line-height: 32px;
      white-space: pre-line;

      @include phone {
        font-size: 16px;
        line-height: 28px;
      }
    }
    &-showMore {
      color: $red;
      font-weight: 600;
      cursor: pointer;
      white-space: nowrap;

      svg {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        /* margin-left: 4px; */
        display: inline-block;
        flex-shrink: 0;
      }
    }
    @include middle {
      padding: 100px 0;
    }
    @include tablet {
      
      padding: 64px 0 56px;
      gap: 20px;

    }

    @include phone {
      align-items: center;
      flex-direction: column;
      padding: 40px 0;
      gap: 32px;
    }
  }
  .singleParams {
    color: #1F1E1E;
    
     &-props {
      display: flex;
      gap: 20px;

      .singleParams-section {
        padding: 4px 0;
      }

      @include tablet {
        gap: 12px;
        flex-wrap: wrap;
        row-gap: 0;
      }

      @include phone {
        margin-top: 10px;
        gap: 12px;
      }
    }
   

   &-location {
    margin-top: 12px;
    font-size: 18px;

    @include tablet {
      font-size: 16px;
      margin-top: 12px;
    }


    @include phone {
      margin-top: 8px;
      font-size: 16px;
    }
    
   }
    
    
    &-section {
      display: flex;
      flex-direction: column;
      align-items: left;
      padding: 12px 0;
      @include gap(15px, col);
      @include middle {
        min-width: auto;
        /* width: 100%; */
        @include gap(10px, col);
        /* padding: 24px 0; */
      }

      @include tablet {
        padding: 12px 0;
      }

      @include phone {
        padding: 12px 0 0 0;

        &:nth-child(4) {
          display: none;
        }
      }

      &._price {
        min-width: 220px;
        position: relative;
        .svg-tip:hover + .singleParams-tip {
          opacity: 1;
        }

        .singleParams-key {
          font-size: 26px;
          font-weight: bold;
          line-height: 26px;

          @include tablet {
            font-size: 24px;
            
          }
        }

        @include middle {
          min-width: auto;
        }
        @include tablet {
          min-width: 150px;
          position: static;
        }
      }

    }
    &-key {
      font-weight: 400;
      font-size: 18px;
      line-height: 18px;
      display: flex;
      align-items: center;
      gap: 8px;

      

      @include tablet {
        font-size: 24px;

      }
      @include middle {
        font-size: 16px;
      }

      @include phone {
        font-size: 16px;
        gap: 4px;
      }
    }
    &-value {
      font-weight: 300;
      font-size: 14px;
      line-height: 17px;
      display: none;
      @include middle {
        font-size: 10px;
      }
      &._price {
        /* display: flex; */
        display: none;
        @include gap(10px, row);
        align-items: center;
      }
      @include tablet {
        font-size: 16px;
      }


    }
    &-tip {
      position: absolute;
      white-space: nowrap;
      // bottom: -20px;
      transform: translateY(100%);
      left: -10px;
      padding: 20px;
      font-size: 16px;
      line-height: 19px;
      background: white;
      filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.15));
      opacity: 0;
      transition: opacity 0.2s;
      &::after {
        content: '';
        position: absolute;
        left: 123px;
        border: 10px solid transparent;
        border-bottom: 10px solid white;
        top: -19px;
        @include tablet {
          left: 54%;
        }
      }
      @include tablet {
        bottom: auto;
        left: 0;
        width: 100%;
        text-align: center;
        margin: 0 !important;
        // white-space: normal;
      }
    }
  }
</style>
